import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: `${environment.BASE_API_URL}/${environment.UAA_SERVICE}`,
    redirectUrl: window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin,
    postLoginRoute: '/auth/callback',
    clientId: 'frontend-client',
    scope: 'openid profile offline_access', // Essential for refresh token
    responseType: 'code',
    silentRenew: true, //Auto-retriggere refresh in background
    silentRenewUrl: window.location.origin + '/silent-renew.html',
    renewTimeBeforeTokenExpiresInSeconds: 120,
    tokenRefreshInSeconds: 10,
    triggerRefreshWhenIdTokenExpired: false,
    allowUnsafeReuseRefreshToken: true,
    autoUserInfo: false,
    logLevel: LogLevel.Warn,
    useRefreshToken: true, // Uses refresh token flow
    ignoreNonceAfterRefresh: true,
    maxIdTokenIatOffsetAllowedInSeconds: 86400,
  },
};
